import { createContext, useContext, useEffect, useState } from "react";
import { getActiveFestival } from "../lib/api";

const FestivalContext = createContext({ festival: null });

export const FestivalProvider = ({ children }) => {
  const [festival, setFestival] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getActiveFestival()
      .then((f) => {
        if (!cancelled) setFestival(f || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  // Applica l'accento del tema come variabile CSS globale
  useEffect(() => {
    const root = document.documentElement;
    if (festival && festival.accent) {
      root.style.setProperty("--fest-accent", festival.accent);
    } else {
      root.style.removeProperty("--fest-accent");
    }
  }, [festival]);

  return (
    <FestivalContext.Provider value={{ festival }}>
      {children}
    </FestivalContext.Provider>
  );
};

export const useFestival = () => useContext(FestivalContext);
